import actions from "./actions";

const logout = () => ( dispatch ) => {
  window.authManager.logout();
  dispatch(actions.logout);
};

const login = () => ( dispatch ) => {
  window.authManager.login().then(
    response => dispatch(actions.loadAuthSuccess(response)),
    error => dispatch(actions.loadAuthFail(error))
  )
}

const checkAuth = () => ( dispatch ) => {
  window.authManager.checkLogin().then(
    response => dispatch(actions.loadAuthSuccess(response)),
    error => dispatch(actions.loadAuthFail(error))
  )
}

const setIsCertifier = actions.setIsCertifier;
const setIsReadOnly = actions.setIsReadOnly;
const setIsAdmin = actions.setIsAdmin;
const setNoRoles = actions.setNoRoles;
const loadPerimeterToken = actions.loadPerimeterToken;
const loadPointOfOriginToken = actions.loadPointOfOriginToken;
const setUserSession = actions.setUserSession;
const setUserLayers = actions.setUserLayers;
const setUpdatePrompt = actions.setUpdatePrompt;

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  logout,
  login,
  checkAuth,
  setIsCertifier,
  setIsReadOnly,
  setIsAdmin,
  setNoRoles,
  loadPerimeterToken,
  loadPointOfOriginToken,
  setUserSession,
  setUserLayers,
  setUpdatePrompt,
};
